package com.tixforgigs.common.ui.components.images


import io.kvision.core.Container
import io.kvision.event.clickFlow
import io.kvision.html.CustomTag
import io.kvision.html.customTag
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach

@OptIn(DelicateCoroutinesApi::class)
fun Container.svg(
  width: Int? = null,
  height: Int? = null,
  //x: Int? = null,
  //y: Int? = null,
  className: String = "xm-logo",
  viewBox: String? = null,
  //preserveAspectRatio: String? = null,
  //enableBackground: String? = null,
  onClick: () -> Unit = {},
  block: CustomTag.() -> Unit = {}
) {
  customTag("svg") {
    //setAttribute("version", "1.1")
    //setAttribute("xmlns", "http://www.w3.org/2000/svg")
    setAttribute("class", className)
    width?.let { setAttribute("width", "$it") }
    height?.let { setAttribute("height", "$height") }
    viewBox?.let { setAttribute("viewBox", viewBox) }
    block()
  }.clickFlow.onEach {
    onClick.invoke()
  }.launchIn(GlobalScope)
}

fun CustomTag.path(color: String?, d: String) {
  customTag("path") {
    color?.let { setAttribute("fill", it) }
    setAttribute("d", d)
    setAttribute("stroke-width", "0")
  }
}

fun CustomTag.image(absolutPath: String, width: Int, height: Int, fallbackAbsolutPath: String? = null) {
  customTag("image") {
    setAttribute("xlink:href", absolutPath)
    fallbackAbsolutPath?.let { setAttribute("src", it) }
    setAttribute("width", "$width")
    setAttribute("height", "$height")
  }
}
